import { Text, Image, Anchor, AnchorProps, Flex, getSecureRedirect, useHasImageLoaded } from "@govlaunch/web";
import React from "react";

interface IStoryNewsworthyItemProps {
  newsworthy: {
    url: string;
    title: string;
    description: string | null;
    favicon: string | null;
    siteName: string;
  };
  isMobile?: boolean | null;
}

export default function StoryNewsworthyItem({
  newsworthy,
  isMobile,
  ...props
}: IStoryNewsworthyItemProps & AnchorProps) {
  const faviconUrl = newsworthy.favicon ? getSecureRedirect(newsworthy.favicon, "outside-govlaunch") : undefined;
  const shouldDisplayImage = useHasImageLoaded({ src: faviconUrl });
  const title = newsworthy.title || newsworthy.siteName || new URL(newsworthy.url || "").hostname;

  return (
    <Anchor
      title={title}
      aria-label={title}
      external="outside-govlaunch"
      href={newsworthy.url}
      display="flex"
      flexWrap="wrap"
      justifyContent="flex-start"
      flex="1 1 auto"
      overflow="hidden"
      minHeight={isMobile ? "95px" : "131px"}
      py={isMobile ? 0 : 6}
      paddingLeft={0}
      paddingRight={8}
      _hover={{
        textDecoration: "none",
        boxShadow: "md",
      }}
      {...props}
    >
      <Text color="blue.600" isTruncated={true} fontWeight="semibold" fontSize="md" title={title} width="100%">
        {title}
      </Text>

      {newsworthy.description && (
        <Text color="black" clamp={2} fontSize="sm" title={newsworthy.description} width="100%">
          {newsworthy.description.trim()}
        </Text>
      )}

      <Flex align="center" mt={3}>
        {newsworthy.favicon && shouldDisplayImage && (
          <Image
            width={6}
            height={6}
            src={newsworthy.favicon}
            external={newsworthy.favicon?.startsWith("https") ? "govlaunch" : "outside-redirect"}
            alt="link favicon"
            mr={2}
          />
        )}

        <Text color="black" isTruncated={true} fontSize="sm" mb={0}>
          {title}
        </Text>
      </Flex>
    </Anchor>
  );
}
